import { render, staticRenderFns } from "./AllBlogsCard.vue?vue&type=template&id=859654e6&scoped=true&"
import script from "./AllBlogsCard.vue?vue&type=script&lang=js&"
export * from "./AllBlogsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859654e6",
  null
  
)

export default component.exports